
const ScopeReportIntroPage = ({ SafeFormattedMessage,email, datePassed, pageNumber, pageNumbers, logo }) => (
    <div className="PageCharts-chart">
       <div className="header-logo-box">
            <img
                alt="ppe-logo"
                className="header-logo-img"
                src={logo}/>
        </div>
        <div className="report-alt-page">
            <div className="centered-title">
                <span className="intro-title">
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_TITLE"} />
                </span>
            </div>

            <p className="bottom-margin-10">
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_WELCOME"} />
            </p>

            <p>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_DISTINCTION"} />
            </p>

            <ol>
                <li>
                <b><SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SELF_EVAL_SUBTITLE"} /></b>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SELF_EVAL"} />
                </li>
                <li>
                <b><SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_OBJECTIVE_EVAL_SUBTITLE"} /></b>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_OBJECTIVE_EVAL"} />
                </li>
            </ol>

            <div className="centered-hr">
                <hr className="fullwidth-hr" />
            </div>

            <p className="bottom-margin-10">
                <b><SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_HOW_TO_READ_TITLE"} /></b>
            </p>

            <p className="bottom-margin-10">
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_HOW_TO_READ_DESC"} />
            </p>

            <p>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTIONS_TITLE"} />
            </p>

            <ul>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_PERSONALITY"} /> {pageNumbers && pageNumbers[0] ? `${pageNumbers[0]}` : ""}
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_CAPACITIYREASONING"} /> {pageNumbers && pageNumbers[1] ? `${pageNumbers[0] + 3}` : ""}
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_COGNITIVE"} /> {pageNumbers && pageNumbers[1] ? `${pageNumbers[1]}` : ""}
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_EMOTION"} /> {pageNumbers && pageNumbers[2] ? `${pageNumbers[2]}` : ""}
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_ACTION"} /> {pageNumbers && pageNumbers[3] ? `${pageNumbers[3]}` : ""}
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_MOTIVATION"} /> {pageNumbers && pageNumbers[4] ? `${pageNumbers[4]}` : ""}
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_SECTION_VALUES"} /> {pageNumbers && pageNumbers[5] ? `${pageNumbers[5]}` : ""}
                </li>
            </ul>

            <div className="centered-hr">
                <hr className="fullwidth-hr" />
            </div>

            <p>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_KEEP_IN_MIND_TITLE"} />
            </p>

            <ul>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_KEEP_IN_MIND_1"} />
                </li>
                <li>
                <SafeFormattedMessage msgKey={"SCOPE_REPORT_INTRO_KEEP_IN_MIND_2"} />
                </li>
            </ul>
        </div>
        <div className="pdf-footer">
            <SafeFormattedMessage msgKey={"PAGE"} /> {pageNumber}
            <div className="pdf-footer-separator">
            <b><SafeFormattedMessage msgKey={"CANDIDATE"} /></b>
            </div>{" "}
            {email}
            <div className="pdf-footer-separator">
            <b><SafeFormattedMessage msgKey={"TEST_DATE"} /></b> {datePassed}
            </div>
        </div>
    </div>
);

export default ScopeReportIntroPage;